import NextImage from 'next/image';

import { Button } from '../../../../../components/Clickables/Buttons/Button';
import { Heading } from '../../../../../components/Heading/Heading';
import { Text } from '../../../../../components/Text/Text';
import greyFish from '../../../assets/greyFish.svg';

interface IProps {
  title: string;
  description?: string | null;
  withIcon?: boolean;
  className?: string;
  buttonText?: string;
  onClick?: () => void;
}

export const MapDrawerNotification = ({
  title,
  description = '',
  withIcon = false,
  className = '',
  onClick,
  buttonText = '',
}: IProps) => {
  return (
    <div className={`${className} flex w-full flex-col items-center justify-start`}>
      {withIcon && (
        <NextImage alt="fish icon" className="mt-20" width={103} height={65} src={greyFish} />
      )}

      <Heading variant="xs" className="mx-16 mt-10 mb-4 text-center">
        {title}
      </Heading>
      {description !== null && (
        <Text variant="sm" className="mx-12 mb-4 text-center">
          {description}
        </Text>
      )}
      {onClick && buttonText && (
        <Button size="sm" variant="buttonSecondaryVariant" onClick={onClick}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};
